<mat-toolbar  color="primary" class="toolbar">

  <span>  <a href="/" name="PolarVisor homepage">
        <img src="../../../../../assets/images/polarvisor-logo.svg" alt="PolarVisor Homepage" title="PolarVisor Homepage" />
      </a>
   </span>
  <!-- Add additional toolbar items here -->
  <span class="spacer"></span>
  <div class="mt-1 me-3">
    <app-language-switcher></app-language-switcher>
  </div>


</mat-toolbar>
